import { Link, useLocation } from "react-router-dom";
import { logo } from "../../../Assets/images";

import { useSelector } from "react-redux";
import "./style.css";

export const LINKS = [
  // {
  //   to: "/dashboard",
  //   title: "Dashboard",
  //   icon: faBorderAll
  // },
  {
    id: 1,
    to: "/resident-approvals",
    title: "Resident Approvals",
  },
  {
    id: 12,
    to: "/review-approvals",
    title: "Review Moderation",
  },
  {
    id: 2,
    to: "/vendor-requests",
    title: "Vendor Approval Requests",
  },
  {
    id: 3,
    to: "/profiles",
    title: "View Profiles",
  },
  {
    id: 13,
    to: "/vendor-ads",
    title: "Vendor Ads",
  },
  {
    id: 14,
    to: "/ad-pricing",
    title: "Ad Pricing",
  },
  {
    id: 5,
    to: "/categories",
    title: "Categories",
  },
  {
    id: 7,
    to: "/payment-logs",
    title: "Payment Logs",
  },
  {
    id: 8,
    to: "/push-notifications",
    title: "Notifications",
  },
  {
    id: 10,
    to: "/neighborhoods",
    title: "Neighborhoods",
    superAdminOnly: false
  },
  {
    id: 11,
    to: "/admins",
    title: "Admin Management",
    superAdminOnly: true
  },
  {
    id: 15,
    to: "/family-management",
    title: "Marshall",
  },
  {
    id: 16,
    to: "/rangefinder",
    title: "Rangefinder",
  },
]

export const Sidebar = (props) => {

  const { user } = useSelector(state => state.authSlice)
  const location = useLocation()

  // Filter routes based on user access and role
  let ROUTES = user?.access_to?.length > 0
    ? LINKS.filter(item => user.access_to?.includes(item.id))
    : LINKS

  // Filter super admin only routes
  ROUTES = ROUTES.filter(item => {
    if (item.superAdminOnly && user?.role !== 'super_admin') {
      return false
    }
    return true
  })

  return (
    <div className={`sidebar ${props.sideClass}`} id="sidebar">
      <Link to={"/vendor-requests"} className="siteLogo order-2 order-lg-1 py-3">
        <img src={logo} alt="The Turn" className="siteLogoMark" />
      </Link>
      <p className="sidebarSectionLabel">Operations</p>
      <ul className="list-unstyled mt-5">
        {
          ROUTES.map((item) => (
            <li key={item.to} className="sidebar-li">
              <Link className={`sideLink ${location.pathname.includes(item.to) ? 'active' : ''}`} to={item.to}>
                {/* <span className="sideIcon">
                  <FontAwesomeIcon icon={item.icon} />
                </span> */}
                <span className="sideLinkText">{item.title}</span>
              </Link>
            </li>
          ))
        }
      </ul>
    </div>
  );
};
